import React, { useState } from 'react'
import { PhaseGroup, PhaseWrapper } from '../style'
import { Checkbox, Divider, Form } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'
import CreatePhasesModal from './CreatePhasesModal'
import cloneDeep from 'lodash.clonedeep'
import InfoPopup from '~/components/InfoPopup'

export const monthsArray = [
  { key: 1, label: '1 Monat' },
  { key: 2, label: '2 Monate' },
  { key: 3, label: '3 Monate' },
  { key: 4, label: '4 Monate' },
  { key: 5, label: '5 Monate' },
  { key: 6, label: '6 Monate' },
  { key: 7, label: '7 Monate' },
  { key: 8, label: '8 Monate' },
  { key: 9, label: '9 Monate' },
  { key: 10, label: '10 Monate' },
  { key: 11, label: '11 Monate' }
];

const Phases: React.FC = () => {
  const { t } = useTranslation()
  const { control, setValue, getValues } = useFormContext()

  const watchPhaseEnabled = useWatch({ control, name: 'phaseFeeding' })
  const watchFeedingPhases = useWatch({ control, name: 'feedingPhases' })

  const [isPhaseModalOpen, setIsPhaseModalOpen] = useState(false)

  function renderPhaseModal() {
    return <CreatePhasesModal
      isModalOpen={isPhaseModalOpen}
      handleClose={(submited) => {
        if (!submited) {
          setValue('phaseFeeding', 0)
        }
        setIsPhaseModalOpen(false)
      }}
    />
  }

  function renderPhases() {
    return <PhaseGroup>
      {watchFeedingPhases?.map((phase, index) => {
        return <Form.Select
          value={phase.months}
          key={phase.name}
          label={phase.name}
          disabled={watchPhaseEnabled === 0}
          options={monthsArray.map(month => ({ value: month.key, text: month.label }))}
          style={{ width: 180 }}
          onChange={(e, data) => {
            const tempArray = [...watchFeedingPhases]
            tempArray[index].months = parseInt(data.value.toString())
            tempArray[1 - index].months = 12 - parseInt(data.value.toString())
            const feedGroups = cloneDeep(getValues('feedGroups'))
            feedGroups.forEach((feedGroup, feedGroupIndex) => {
              feedGroup?.feedingPhases?.forEach((feedingPhase, index) => {
                feedGroups[feedGroupIndex].feedingPhases[index] = {
                  ...feedingPhase,
                  ...tempArray[index]
                }
              })
            })
            setValue('feedGroups', feedGroups)
            setValue('feedingPhases', tempArray)
          }}
          selectOnBlur={false}
          selection
        />
      })}
    </PhaseGroup>
  }

  return <div>
    <PhaseWrapper>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <Checkbox
          label={t('Do you use phase feeding?')}
          checked={watchPhaseEnabled === 1}
          onChange={(e, data) => {
            setValue('phaseFeeding', data.checked ? 1 : 0)
            setIsPhaseModalOpen(data.checked && watchFeedingPhases?.length === 0)
            if (!data.checked) {
              const feedGroups = cloneDeep(getValues('feedGroups'))
              feedGroups.forEach(feedGroup => {
                feedGroup.feedingPhases = []
                feedGroup.concentratedFeeds = []
                feedGroup.juicyFeeds = []
                feedGroup.coarseFeeds = []
              })
              setValue('feedGroups', feedGroups)
              setValue('feedingPhases', [])
            }
          }}
        />
        <InfoPopup
          content={t('If you feed different rations within your performance groups throughout the year (e.g. summer months with pasture, grazing), you can specify these here.')}
          styleIcon={{ fontSize: '1.3em' }}
          position={'top center'}
        />
      </div>
      <Divider />
    </PhaseWrapper>
    {renderPhases()}
    {renderPhaseModal()}
  </div>
}
export default Phases